import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Stack } from 'react-bootstrap';
import imageCompression from "browser-image-compression";
import db from "../../../../api/mongodb";
import { useNavigate } from 'react-router-dom';
import Lottie from 'react-lottie';
import { defaultOptions1 } from '../../../../config/loading-config';


const BugReportPopup = ({ showPopup, handleCloseModal }) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const formik = useFormik({
        initialValues: {
            description: '',
            files: []
        },
        onSubmit: values => {
            console.log(values)
            if (values.description.length < 1) {
                setError(true)
                return
            }
            setLoading(true)
            console.log(files)
            setError(false)
            const response = db
                .get(`api/safeAPs/isLoggedIn`, {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                })
                .then((response) => {
                    console.log(response)
                    db.post(`api/safeAPs/${response.data.id}/postBug`, {
                        description: values.description,
                        photos: [...files],
                        firstName: response.data.fullName.first,
                        lastName: response.data.fullName.last
                    }, {
                        headers: {
                            Authorization: `${localStorage.getItem("token")}`,
                        }
                    })
                        .then(() => {
                            setLoading(false)

                            setErrorMessage("")
                            setSuccessMessage("Issue reported!")
                        })
                        .catch(error => {
                            console.log(error)
                            setLoading(false)

                            setErrorMessage("An error occured please try again later")
                            setSuccessMessage("")
                        })

                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status === 401) {
                        navigate("/")
                        return
                    }
                    setLoading(false)

                    setErrorMessage("An error occured, please try gain later")
                    setSuccessMessage("")
                })


        }
    })
    const [files, setFiles] = useState([])
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [successMessage, setSuccessMessage] = useState("")

    const handlePhotos = async (e) => {
        console.log(e.target.files)
        var obj = [...files];

        var fileArray = Array.from(e.target.files)

        // Array.from(e.target.files).forEach(async file => {
        //       var file = await compressPhoto(file)
        //       var tempFile = new File([file], file.name, { type: file.type })
        //       var fileObj = { file: tempFile, content: "" }

        //       fileObj.content = await getFileContent(file)
        //       console.log(fileObj)
        //       obj.push(fileObj)
        // });
        //   console.log(e.target.files)
        for (var i = 0; i < fileArray.length; i++) {

            var file = await compressPhoto(fileArray[i])
            var tempFile = new File([file], file.name, { type: file.type })
            var fileObj = { file: tempFile, content: "", name: tempFile.name }

            fileObj.content = await getFileContent(file)
            fileObj.name = tempFile.name
            // console.log(fileObj)
            obj.push(fileObj)

        }

        setFiles(obj)
        //   e.target.value = ''
        // console.log(obj)
    }

    const compressPhoto = async (fileObj) => {
        const options = {
            maxSizeMB: 0.1,
            maxWidthOrHeight: 1920,
            useWebWorker: false
        }

        try {
            const compressedFile = await imageCompression(fileObj, options);
            console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

            // await uploadToServer(compressedFile); // write your own logic

            // console.log(url)
            return (compressedFile)

        } catch (error) {
            console.log(error);
        }
    }

    const getFileContent = (file) => {
        var temporaryFileReader = new FileReader()


        return new Promise((resolve, reject) => {
            temporaryFileReader.onerror = () => {
                temporaryFileReader.abort();
                reject(new DOMException("Problem parsing input file."));
            };

            temporaryFileReader.onload = () => {
                resolve(temporaryFileReader.result);
            };
            temporaryFileReader.readAsDataURL(file)
        });
    }


    return (
        <Modal
            show={showPopup}
            size="xl"
            // backdrop="static"
            keyboard={false}
            onHide={handleCloseModal}
            // onBackdropClick={handleCloseModal}
            centered
            scrollable
            style={{ zIndex: 10000 }}
        >
            <Modal.Header>
                Please report an issue<br /> {loading ?
                    <div style={{ width: "40px" }}>
                        <Lottie options={defaultOptions1} height={40} width={30} />
                    </div>
                    : null}
            </Modal.Header>
            <Modal.Body>
                {errorMessage ? <p style={{ color: "red" }}>{errorMessage}</p> : null}
                {successMessage ? <p style={{ color: "green" }}>{successMessage}</p> : null}

                <Form>
                    <Form.Group>
                        <Form.Label>
                            Please describe the issue to the best of your ability <span style={{ color: "red" }}>* Required</span>
                        </Form.Label>
                        {/* <br /> */}
                        <Form.Control
                            as="textarea"
                            onChange={formik.handleChange('description')}
                            value={formik.values.description}
                            style={{ borderColor: error ? "red" : "black" }}
                        />
                    </Form.Group>

                    <br />
                    Please upload any related screenshots
                    <br />

                    <input type='file' id="button-file"
                        style={{ display: "none" }}
                        accept='image/*'
                        multiple onChange={handlePhotos}
                    />
                    <label htmlFor='button-file'>
                        <span
                            style={{
                                textDecoration: "underline",
                                color: "#112c54",
                                fontWeight: "bold",
                                cursor: "pointer"

                            }}
                        >Upload photos</span>
                    </label>
                    <Stack direction='horizontal' gap={3}>
                        {
                            files.map((file, i) => {
                                return (
                                    <div key={i}>
                                        <img src={file.content} alt={file.file.name} style={{ height: "60px", width: "auto" }} />
                                        <p>{file.file.name}</p>
                                        <Button
                                            variant='danger'
                                            onClick={() => {
                                                // console.log(i)
                                                var obj = [...files]
                                                obj.splice(i, 1)
                                                setFiles(obj)
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                )
                            })
                        }
                    </Stack>



                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" disabled={loading} onClick={formik.handleSubmit}>
                    Submit an issue
                </Button>
                <Button variant="secondary" onClick={() => {
                    setFiles([])
                    setError(false)
                    setErrorMessage("")
                    setSuccessMessage("")
                    formik.values.description=""
                    handleCloseModal()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BugReportPopup;